
import React from 'react';
import TheNav from '../Components/navbar';
import SEO from "../Components/SEO";

export default function RefundPolicy() {
    return (
        <>
            <SEO
                title="Refund Policy | Kre8 Content"
                description="Read the Kre8 Content refund policy for creator and editor orders, response timing, and resolution steps."
                canonicalPath="/legal/refund"
            />
            <TheNav />

            <main className="max-w-3xl mx-auto px-4 py-16 text-white">
                <h1 className="text-3xl font-bold mb-4">Refund Policy</h1>
                <p className="mb-6">
                    At Kre8Content we strive for 100% satisfaction. If you ever feel you need a refund, just let us know:
                </p>
                <ul className="list-disc list-inside mb-6">
                    <li>Submit your refund request via our support channel.</li>
                    <li>We’ll acknowledge within <strong>48 hours</strong>.</li>
                    <li>
                        We’ll then work directly with both the creator and editor to reach a
                        fair resolution.
                    </li>
                </ul>
                <h2 className="text-2xl font-bold mb-3">Clipping campaign refunds</h2>
                <p className="mb-6">
                    A funded clipping campaign includes a 60 day commitment beginning when Stripe confirms payment. Platform and payment processing fees are not refundable. After the commitment ends, the creator may close the campaign and request the unused campaign budget once submissions, appeals, disputes, and payout reservations are resolved. Approved clipper earnings are not part of the unused budget. Refunds are returned to the original payment method and generally appear within 5 to 10 business days after Stripe processes them.
                </p>
                <p>
                    Questions? Reach out to us at{' '}
                    <a href="mailto:support@kre8content.com" className="text-white underline">
                        support@kre8content.com
                    </a>
                    .
                </p>
            </main>
        </>
    );
}
